import Caption from '@zenbusiness/common-components/Caption';
import { generateUrl } from '@zenbusiness/common-components/SharedAsset';
import Text from '@zenbusiness/common-components/Text';

import MuiButton from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import MuiCardActions from '@mui/material/CardActions';
import MuiCardContent from '@mui/material/CardContent';
import { styled } from '@mui/material/styles';
import withStyles from '@mui/styles/withStyles';

import IntercomButton from '#client/components/Intercom';

const messages = {
  labels: {
    title: 'ZenBusiness Domain',
    externalTitle: 'Domain'
  }
};

const StyledCardRoot = styled(Card)(() => ({
  width: '100%'
}));

const StyledTextCardContent = styled(Text)(({ theme }) => ({
  '&.MuiTypography-root': {
    marginTop: theme.spacing(4)
  }
}));

const CardPreview = styled('div')(({ theme }) => ({
  height: theme.spacing(14),
  display: 'flex',
  backgroundColor: theme.palette.peace30.main,
  justifyContent: 'center',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  backgroundImage: `url(${generateUrl('/illustration/website-preview-zenbusiness-256.svg', 170, 170, 'auto')})`
}));

const CardContent = withStyles(() => ({
  root: {
    marginBottom: 0
  }
}))(MuiCardContent);

const CardActions = withStyles((theme) => ({
  root: {
    justifyContent: 'space-between',
    flexDirection: 'column',
    marginBottom: theme.spacing(2),
    minHeight: theme.spacing(14)
  }
}))(MuiCardActions);

const Button = withStyles(() => ({
  root: {
    marginLeft: '0px !important',
    width: '54%'
  }
}))(MuiButton);

const CardIntercomButton = withStyles(() => ({
  root: {
    whiteSpace: 'nowrap',
    width: '54%'
  }
}))(IntercomButton);

const DomainSkippedCard = () => (
  <StyledCardRoot key="domain-skipped">
    <CardActionArea>
      <CardPreview />
      <CardContent align="center">
        <Caption size="lg" color="focus50">
          {messages.labels.title}
        </Caption>
        <StyledTextCardContent size="sm" color="focus40">
          You’ve purchased a domain.
          <br />
          To activate it, chat with us or email us at support@zenbusiness.com
        </StyledTextCardContent>
      </CardContent>
      <CardActions>
        {window.Intercom && (
          <CardIntercomButton
            variant="outlined"
            color="primary"
          >
            CHAT WITH US
          </CardIntercomButton>
        )}
        <Button
          variant="outlined"
          color="primary"
          href="mailto:support@zenbusiness.com"
          target="_blank"
        >
          EMAIL US
        </Button>
      </CardActions>
    </CardActionArea>
  </StyledCardRoot>
);

export default DomainSkippedCard;
